type FormValues = {
    [key: string]: unknown
}

export const trimStringValues = (data: FormValues) => {
    return Object.fromEntries(
        Object.entries(data).map(([key, value]) => {
            if (typeof value === "string") {
                return [key, value.trim()]
            }
            return [key, value]
        }),
    )
}
